<script setup lang="ts">
import { ref } from "vue"

const { hasDecision, acceptAll, rejectAll } = useConsent()
const showPreferences = ref(false)
</script>

<template>
    <div
        v-if="!hasDecision"
        class="consent-banner"
        role="dialog"
        aria-modal="false"
        aria-labelledby="consent-banner-title"
        aria-describedby="consent-banner-desc"
    >
        <div
            class="tw-mx-auto tw-max-w-7xl tw-px-4 tw-py-4 md:tw-py-5 tw-flex tw-flex-col md:tw-flex-row md:tw-items-center tw-gap-4"
        >
            <div class="tw-flex-1">
                <p
                    id="consent-banner-title"
                    class="tw-text-base tw-font-bold tw-text-white tw-m-0"
                >
                    {{ $t("consent.banner.title") }}
                </p>
                <p
                    id="consent-banner-desc"
                    class="tw-text-sm tw-text-white/90 tw-mt-1 tw-mb-0 tw-leading-snug"
                >
                    {{ $t("consent.banner.description") }}
                    <NuxtLink
                        to="/information/cookie-policy"
                        class="tw-underline tw-text-white hover:tw-text-secondary-200"
                    >
                        {{ $t("consent.banner.policy_link") }}
                    </NuxtLink>
                </p>
            </div>

            <div
                class="tw-flex tw-flex-col sm:tw-flex-row tw-gap-2 tw-w-full md:tw-w-auto md:tw-shrink-0"
            >
                <q-btn
                    unelevated
                    no-caps
                    color="white"
                    text-color="primary"
                    class="consent-btn"
                    :label="$t('consent.banner.reject_all')"
                    data-cy="consent-reject-all"
                    @click="rejectAll"
                />
                <q-btn
                    unelevated
                    no-caps
                    color="white"
                    outline
                    class="consent-btn consent-btn-outline"
                    :label="$t('consent.banner.configure')"
                    data-cy="consent-configure"
                    @click="showPreferences = true"
                />
                <q-btn
                    unelevated
                    no-caps
                    color="secondary"
                    text-color="white"
                    class="consent-btn"
                    :label="$t('consent.banner.accept_all')"
                    data-cy="consent-accept-all"
                    @click="acceptAll"
                />
            </div>
        </div>

        <ConsentPreferencesModal v-model="showPreferences" />
    </div>
</template>

<style scoped>
.consent-banner {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 6000;
    background-color: var(--q-primary, #0674bf);
    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.15);
}

.consent-btn {
    min-width: 140px;
    font-weight: 600;
}

.consent-btn-outline {
    border: 1px solid white;
}

@media (max-width: 640px) {
    .consent-btn {
        width: 100%;
        min-width: 0;
    }
}
</style>
